import { createContext, useContext } from 'react';

  
type AppContextType = {
    updateToast: (message: string, view: React.ReactNode) => void;
    successToast: (message: string) => void;
    warningToast: (message: string) => void;
    errorToast: (message: string) => void;
};

const initialType: AppContextType = {
    updateToast: (message: string, view: React.ReactNode) => {},
    successToast: (message: string) => {},
    warningToast: (message: string) => {},
    errorToast: (message: string) => {},
};

export const ToastContext = createContext(initialType);

export const useToast = () => useContext(ToastContext);